export default function authReducer(auth, action) {
  switch (action.type) {
    case "set":
      return action.value;

    case "resetPassword":
      return { ...auth, password: action.value, confirmPassword: action.value };

    default:
      return { ...auth, [action.type]: action.value };
  }
}
